import { create } from "domain";
import React from "react";
import { Columns, User } from "../types/index";
import { useRecoilState } from "recoil";
import { userState } from "../states/userState";
import { setUserToLocalStorage } from "../lib/localStorageManager";
import { createColumnHelper } from "@tanstack/react-table";
import { transform } from "typescript";
import {
  VIEW_ID_5253,
  VIEW_ID_54,
  VIEW_ID_ALL_FACTORY,
  VIEW_ID_PT,
  VIEW_ID_PV,
} from "../commons/views";
interface Result {
  [key: number]: boolean;
}
export const useColumnsSetting = () => {
  const [user, setUser] = useRecoilState<User>(userState);
  const columnHelper = createColumnHelper();
  const getColumns = (viewId: number) => {
    return viewId === VIEW_ID_ALL_FACTORY
      ? user.columnsAllFactory
      : viewId === VIEW_ID_PT
      ? user.columnsPT
      : viewId === VIEW_ID_PV
      ? user.columnsPV
      : viewId === VIEW_ID_54
      ? user.columnsKanto
      : viewId === VIEW_ID_5253
      ? user.columnsFukuokaKumamoto
      : user.columnsSite;
  };
  const createColumnsAndDataSetting = (
    columnsArray: Array<Columns>,
    dataArray: Array<Columns[]>
  ) => {
    //現場か工場かを判定
    console.log("columnsArray", columnsArray, dataArray);
    let newColumns = getColumns(user.viewId);
    let newData = [...dataArray];
    let columns: any[] = [];
    let data: any[] = [];
    // let columnVisibility: { [key: string]: boolean } = {};
    let columnVisibility = {};
    if (newColumns.length === 0) {
      newColumns = [...columnsArray];
      setUser((prevState: User) => {
        let updatedColumns = {
          columnsAllFactory: prevState.columnsAllFactory,
          columnsPT: prevState.columnsPT,
          columnsPV: prevState.columnsPV,
          columnsKanto: prevState.columnsKanto,
          columnsFukuokaKumamoto: prevState.columnsFukuokaKumamoto,
          columnsSite: prevState.columnsSite,
        };

        switch (user.viewId) {
          case VIEW_ID_ALL_FACTORY:
            updatedColumns.columnsAllFactory = newColumns;
            break;
          case VIEW_ID_PT:
            updatedColumns.columnsPT = newColumns;
            break;
          case VIEW_ID_PV:
            updatedColumns.columnsPV = newColumns;
            break;
          case VIEW_ID_54:
            updatedColumns.columnsKanto = newColumns;
            break;
          case VIEW_ID_5253:
            updatedColumns.columnsFukuokaKumamoto = newColumns;
            break;
          default:
            updatedColumns.columnsSite = newColumns;
            break;
        }

        const newUser = { ...prevState, ...updatedColumns };
        setUserToLocalStorage(newUser);
        return newUser;
      });
    }
    // console.log("NewColumns", newColumns);
    columns = newColumns.map((column: Columns) => {
      return columnHelper.accessor(column.columnId, {
        id: column.columnId,
        header: column.dispName,
        enableResizing: false,
        size: column.size,
      });
    });

    data = newData.map((row: Columns[]) => {
      const transformed: any = {};
      row.forEach(({ columnId, value }) => {
        transformed[columnId] = value;
      });
      return transformed;
    });

    const intermediateArray = newColumns.map(({ columnId, isShow }: any) => {
      return [columnId, isShow];
    });
    columnVisibility = Object.fromEntries(intermediateArray);

    const newColumnsAndData = { columns, data, columnVisibility };
    return newColumnsAndData;
  };
  const createColumnsSetting = (
    columnsArray: Array<Columns>,
    dataArray: Array<Columns[]>,
    viewId: number
  ) => {
    let newColumns = [...columnsArray];
    let newData = [...dataArray];
    let columns: any[] = [];
    let data: any[] = [];
    let columnVisibility = {};

    newColumns = [...columnsArray];
    setUser((prevState: User) => {
      let updatedColumns = {
        columnsAllFactory: prevState.columnsAllFactory,
        columnsPT: prevState.columnsPT,
        columnsPV: prevState.columnsPV,
        columnsKanto: prevState.columnsKanto,
        columnsFukuokaKumamoto: prevState.columnsFukuokaKumamoto,
        columnsSite: prevState.columnsSite,
      };

      switch (viewId) {
        case VIEW_ID_ALL_FACTORY:
          updatedColumns.columnsAllFactory = newColumns;
          break;
        case VIEW_ID_PT:
          updatedColumns.columnsPT = newColumns;
          break;
        case VIEW_ID_PV:
          updatedColumns.columnsPV = newColumns;
          break;
        case VIEW_ID_54:
          updatedColumns.columnsKanto = newColumns;
          break;
        case VIEW_ID_5253:
          updatedColumns.columnsFukuokaKumamoto = newColumns;
          break;
        default:
          updatedColumns.columnsSite = newColumns;
          break;
      }

      const newUser = { ...prevState, ...updatedColumns };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const createDataSetting = (dataArray: Array<Columns[]>) => {
    let newData = [...dataArray];
    //表示用のデータを生成する。
    const data = newData.map((row: Columns[]) => {
      const transformed: any = {};
      row.forEach(({ columnId, value }) => {
        transformed[columnId] = value;
      });
      return transformed;
    });
    return data;
  };
  return {
    createColumnsAndDataSetting,
    createColumnsSetting,
    createDataSetting,
  };
};
